import apiClient from '../../authentication/utils/core/axios';

const WatchlistAPI = {
  getFollowedStocks: async ({ skip = 0, limit = 50 } = {}) => {
    try {
      const response = await apiClient.get('/me/stocks', { params: { skip, limit } });
      if (response.status !== 200) throw new Error('Failed to fetch watchlist');
      
      return {
        items: response.data ?? [],
        total: response.data?.length ?? 0,
      };
    } catch (error) {
      console.warn('[WatchlistAPI] getFollowedStocks error:', error);
      throw error;
    }
  },

  followStock: async (stockId = null, symbol = null) => {
    try {
      const payload = {};
      
      if (stockId != null) {
        payload.stock_id = Number(stockId);
      }
      if (symbol) {
        payload.symbol = symbol.toUpperCase();
      }

      if (!payload.stock_id && !payload.symbol) {
        throw new Error("followStock requires either stock_id or symbol");
      }

      //console.log('[WatchlistAPI] Following stock with payload:', payload);
      
      const response = await apiClient.post('/follow-stock/', payload);
      if (![200, 201].includes(response.status)) {
        throw new Error(`Failed to follow stock: ${response.status}`);
      }
      
      return response.data;
    } catch (error) {
      console.warn('[WatchlistAPI] followStock error:', error);
      throw error;
    }
  },

  unfollowStock: async (stockId = null, symbol = null) => {
    try {
      const payload = {};
      
      if (stockId) {
        payload.stock_id = Number(stockId);
      }
      if (symbol) {
        payload.symbol = symbol.toUpperCase();
      }

      if (!payload.stock_id && !payload.symbol) {
        throw new Error("unfollowStock requires either stock_id or symbol");
      }

      //console.log('[WatchlistAPI] Unfollowing stock with payload:', payload);
      
      const response = await apiClient.delete('/unfollow-stock/', { data: payload });
      if (response.status !== 200) {
        throw new Error(`Failed to unfollow stock: ${response.status}`);
      }
      
      return response.data;
    } catch (error) {
      console.warn('[WatchlistAPI] unfollowStock error:', error);
      throw error;
    }
  },
};

export default WatchlistAPI;